import * as ReactRedux from 'react-redux';
import { AppState } from '../app/app.types';
import LeadsComponent from './LeadsComponent';
import { push } from 'react-router-redux';
import { paths } from '../app/app.routes';

const mapDispatchToProps = (dispatch: Function) => {
  return {
    toDashboard: () => dispatch(push(paths.dashboard)),
    toPrograms: () => dispatch(push(paths.programs)),
    toMembers: () => dispatch(push(paths.members)),
    toStaffs: () => dispatch(push(paths.staffs)),
    toAttendancesCheckIn: () => dispatch(push(paths.attendancesCheckIn)),
    toAttendancesHistory: () => dispatch(push(paths.attendancesHistory)),
    toBilling: () => dispatch(push(paths.billing)),
    toPaymentList: () => dispatch(push(paths.paymentList)),
    toPaymentHistory: () => dispatch(push(paths.paymentHistory)),
    toAdminDashboard: () => dispatch(push(paths.adminDashboard)),
    toAdminBusiness: () => dispatch(push(paths.adminBusiness)),
    toAdminAccountRegistration: () => dispatch(push(paths.adminAccountRegistration)),
    toPosSale: () => dispatch(push(paths.posSale)),
    toPosHistory: () => dispatch(push(paths.posHistory)),
    toAdminLockedAccount: () => dispatch(push(paths.adminLockedAccount)),
    toAdminEmailBlast: () => dispatch(push(paths.adminEmailBlast)),
    toPackages: () => dispatch(push(paths.packages)),
    toPackageReport: () => dispatch(push(paths.reports)),
    toLeads: () => dispatch(push(paths.leads))
  };
};

const mapStateToProps = (state: AppState, ownProps) => {
  return {
    authState: state.authState,
    adminState: state.adminState,
    businessState: state.businessState,
    isMobile: ownProps.isMobile,
    open: ownProps.open,
    toggleSidebarHandler: ownProps.toggleSidebarHandler
  };
};

const Leads = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(LeadsComponent);
export default Leads;


// WEBPACK FOOTER //
// ./src/leads/Leads.tsx